import { render, staticRenderFns } from "./contenido_juego_docente.vue?vue&type=template&id=0b68b281"
import script from "./contenido_juego_docente.vue?vue&type=script&lang=js"
export * from "./contenido_juego_docente.vue?vue&type=script&lang=js"
import style0 from "./contenido_juego_docente.vue?vue&type=style&index=0&id=0b68b281&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports